import { AdjustmentsActionTypes } from './constants';

type AdjustmentsAction = { type: string, payload: {} | string };

export const adjustmentsApiResponseSuccess = (actionType: string, data: any): AdjustmentsAction => ({
    type: AdjustmentsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const adjustmentsApiResponseError = (actionType: string, error: string): AdjustmentsAction => ({
    type: AdjustmentsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getAllAdjustments = (query): AdjustmentsAction => ({
    type: AdjustmentsActionTypes.GET_ALL_ADJUSTMENTS,
    payload: { query },
});

export const adjustmentsResetState = (): AdjustmentsAction => ({
    type: AdjustmentsActionTypes.RESET_STATE,
    payload: {},
});

export const adjustmentsResetAllErrors = (): AdjustmentsAction => ({
    type: AdjustmentsActionTypes.RESET_ALL_ERRORS,
    payload: {},
});